import { EntityState, Selector, createSelector } from '@reduxjs/toolkit'
import { IClientWithSettings, SimpleClient } from 'shared/models/Client'
import { RootState } from '../store'
import clientsApi from './clients.service'
import clientReducer, { clientsAdapter } from './reducer'

const _clientStore = (root: RootState) =>
  // @ts-expect-error todo companyinfo does not exist
  root[clientReducer.name] as EntityState<IClientWithSettings> & {
    currentId: string | null
    clients: SimpleClient[]
    isSettingClient: boolean
  }

const clientSelectors = clientsAdapter.getSelectors(
  (x: RootState) => x[clientReducer.name]
)

const getAllClients = (root: RootState) => clientSelectors.selectAll(root)

export const getActiveClientId: Selector<RootState, string | null> =
  createSelector(_clientStore, ({ currentId }) => currentId)

export const getActiveClient: Selector<RootState, IClientWithSettings> =
  createSelector([getAllClients, _clientStore], (clients, { currentId }) => {
    if (!currentId) return

    return clients.find(
      (client: IClientWithSettings) => client.id === currentId
    )
  })

export const getClientSettings = createSelector(
  [getActiveClient],
  (client) => client?.portalAvailable || []
)

export const getIsPortalLight = createSelector(
  [getActiveClient],
  (client) => client?.hasLightSystem || false
)

export const getClients = createSelector(_clientStore, ({ clients }) => clients)

export const clientApiSelector = (id: string | null) =>
  clientsApi.endpoints.getClient.select(id || '')

export const getIsSettingClient = createSelector(
  _clientStore,
  ({ isSettingClient }) => isSettingClient
)
